/* eslint-disable */
import Selectr from 'mobius1-selectr'

window.addEventListener('load', () => {
    const select = document.querySelectorAll('select')
    for (let index = 0; index < select.length; index++) {
        const element = select[index]
        new Selectr(element, {
            searchable: false
        })
    }
})



// WEBPACK FOOTER //
// ./js/modules/form/select.js